const GYM_ROOM_COLOR = 'rgb(25, 212, 179)'

export { GYM_ROOM_COLOR }
